// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__ZTr9z","title":"FrontImage_title__2qclg"};